export default "__VITE_ASSET__14ae3a35__"